import { useEffect, useRef } from 'react';
import Raven from 'raven-js';
import { useTrackPlanVisitedMutation } from '../../__generated__/chirp/com/hubspot/deal/plans/rpc/DealPlanEngagementTrackingPortalRpc.hooks';

// Ensure we only call the plan visited event once per session
export function useTrackPlanVisited(dealPlanId, options) {
  const [trackPlanVisited] = useTrackPlanVisitedMutation();
  const hasTracked = useRef(false);
  useEffect(() => {
    if (!options.skip && !hasTracked.current) {
      hasTracked.current = true;
      trackPlanVisited({
        variables: {
          objectId: dealPlanId
        }
      }).catch(err => {
        Raven.captureException(new Error('Failed to track plan visited', {
          cause: err
        }));
      });
    }
    // dealPlanId is intentionally omitted: this hook is mounted once per plan
    // and relies on component unmount/remount for plan navigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.skip]);
}